import { createNetworkActions } from "~/utils/actions";

export default {
	...createNetworkActions("GET_SL_PRICES"),
	...createNetworkActions("GET_PKB_PRICES"),
	...createNetworkActions("GET_POLICY_PRICES"),
	...createNetworkActions("GET_FUND_PRICES"),
};
